module.exports = __webpack_public_path__ + "img/download-icon.74ba0872.svg";